// Whether an appointment has started, from its real start instant (the API's UTC
// startTime). Never pass a calendar event's `start`: that's the shop's wall clock
// dressed as a local Date, which is off by the gap between the shop's time zone and
// the viewer's - from India, 11.5 hours early for a Chicago shop.
export const hasAppointmentStarted = (startTime: string | Date | null | undefined, now: number = Date.now()) => {
    if (!startTime) return false;
    const start = new Date(startTime).getTime();
    return !Number.isNaN(start) && start <= now;
};
